import Vue from 'vue';
import VueRouter from 'vue-router';
import Properties from '../views/Properties.vue';
import Property from '../views/Property.vue';
import Slideshow from '../views/Slideshow.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: Slideshow,
  },
  {
    path: '/properties/:subcategory_id',
    name: 'Properties',
    component: Properties,
    props: true,
  },
  {
    path: '/property/:id',
    name: 'Property',
    component: Property,
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
